<div
  class="topDiv"
  style="margin-top: 4%;   z-index: 0"
> <div class="headerStyle title">
  Full Data Load
</div>
  <div
    class="agGridOuterDiv"
    style="padding-left: 10px; padding-right: 10px; height: 100%"
  >
    <div class="baselineDataLoadSection">
      <!-- removed dsiplaydata condition from here and applied where data binding from backend -->
      <div class="baselineDataLoadBodyDiv">
        <div style="width: 100%; display: flex">
          <div style="width: 30%; display: inline-block">
            <div class="dataExtractionSection">
              <div style="width: fit-content; margin: 10px auto">
                <h3>1</h3>
              </div>

              <div class="dataExtractionHeaderDiv">
                <h5>Extract</h5>
              </div>

              <div [class.spinner]="loading"></div>

              <div class="keyValueCss">
                <span class="keyCss">Initiated Date & Time</span>
                <span class="colonCss">:</span>
                <span
                  class="valueCss"
                  [title]="masterDataLoadLogObject[2]['initiateddateandtime']"
                  *ngIf="displayData"
                  >{{
                    masterDataLoadLogObject[2]["initiateddateandtime"]
                  }}</span
                >
              </div>
              <div class="keyValueCss">
                <span class="keyCss">Status</span>
                <span class="colonCss">:</span>
                <span
                  class="valueCss"
                  [title]="masterDataLoadLogObject[2]['status']"
                  *ngIf="displayData"
                  >{{ masterDataLoadLogObject[2]["status"] }}</span
                >
              </div>
              <div class="keyValueCss">
                <span class="keyCss">Completed Date & Time</span>
                <span class="colonCss">:</span>
                <span
                  class="valueCss"
                  [title]="masterDataLoadLogObject[2]['completeddateandtime']"
                  *ngIf="displayData"
                  >{{
                    masterDataLoadLogObject[2]["completeddateandtime"]
                  }}</span
                >
              </div>
            </div>
          </div>

          <div style="margin: auto; display: inline-block">
            <div style="font-size: xx-large">
              <em class="fas fa-arrow-alt-circle-right"></em>
            </div>
          </div>

          <div style="width: 30%; display: inline-block">
            <div class="conversionToJsonSection">
              <div style="width: fit-content; margin: 10px auto">
                <h3>2</h3>
              </div>
              <div class="conversionToJsonHeaderDiv">
                <h5>Convert</h5>
              </div>

              <div [class.spinner1]="loading1"></div>

              <div class="keyValueCss">
                <span class="keyCss">Initiated Date & Time</span>
                <span class="colonCss">:</span>
                <span
                  class="valueCss"
                  [title]="masterDataLoadLogObject[1]['initiateddateandtime']"
                  *ngIf="displayData"
                  >{{
                    masterDataLoadLogObject[1]["initiateddateandtime"]
                  }}</span
                >
              </div>
              <div class="keyValueCss">
                <span class="keyCss">Status</span>
                <span class="colonCss">:</span>
                <span
                  class="valueCss"
                  [title]="masterDataLoadLogObject[1]['status']"
                  *ngIf="displayData"
                  >{{ masterDataLoadLogObject[1]["status"] }}</span
                >
              </div>
              <div class="keyValueCss">
                <span class="keyCss">Completed Date & Time</span>
                <span class="colonCss">:</span>
                <span
                  class="valueCss"
                  [title]="masterDataLoadLogObject[1]['completeddateandtime']"
                  *ngIf="displayData"
                  >{{
                    masterDataLoadLogObject[1]["completeddateandtime"]
                  }}</span
                >
              </div>
            </div>
          </div>

          <div style="margin: auto; display: inline-block">
            <div style="font-size: xx-large">
              <em class="fas fa-arrow-alt-circle-right"></em>
            </div>
          </div>

          <div style="width: 30%; display: inline-block">
            <div class="storingToS3Section">
              <div style="width: fit-content; margin: 10px auto">
                <h3>3</h3>
              </div>
              <div class="storingToS3HeaderDiv">
                <h5>Store</h5>
              </div>

              <div [class.spinner2]="loading2"></div>

              <div class="keyValueCss">
                <span class="keyCss">Initiated Date & Time</span>
                <span class="colonCss">:</span>
                <span
                  class="valueCss"
                  [title]="masterDataLoadLogObject[0]['initiateddateandtime']"
                  *ngIf="displayData"
                  >{{
                    masterDataLoadLogObject[0]["initiateddateandtime"]
                  }}</span
                >
              </div>
              <div class="keyValueCss">
                <span class="keyCss">Status</span>
                <span class="colonCss">:</span>
                <span
                  class="valueCss"
                  [title]="masterDataLoadLogObject[0]['status']"
                  *ngIf="displayData"
                  >{{ masterDataLoadLogObject[0]["status"] }}</span
                >
              </div>
              <div class="keyValueCss">
                <span class="keyCss">Completed Date & Time</span>
                <span class="colonCss">:</span>
                <span
                  class="valueCss"
                  [title]="masterDataLoadLogObject[0]['completeddateandtime']"
                  *ngIf="displayData"
                  >{{
                    masterDataLoadLogObject[0]["completeddateandtime"]
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            margin-top: 24px;
            margin-bottom: 24px;
          "
        >
          <button
            type="button"
            id="dataLoad"
            class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding: 0.3rem 1.6rem; font-size: 0.85rem; width: 180px"
            (click)="extractConvertLoad()"
            [style.background-color]="backgroundColorButton"
          >
            Process Dataload
          </button>
        </div>
        <div style="margin-bottom: 7vh">
          <mat-toolbar
            class="agGridtoperDiv card"
            style="
              background: rgb(228 227 230 / 41%);
              border-top: 1px solid #a9a9a9a8;
              border-right: 1px solid #a9a9a9a8;
              border-left: 1px solid #a9a9a9a8;
              margin-right: 0%;
            "
          >
            <label i18n="@@spmsUserReg" class="textColour"
              >Full Data Load Logs</label
            >

            <span class="example-spacer"></span>
            <button
              class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              title="Download"
              (click)="onBtExport()"
            >
              Download
              <em
                style="padding: 0px 0px 0px 10px"
                class="fas fa-download example-icon"
                title="Download"
              ></em>
            </button>
            <div class="insertPageNoDiv">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                <input
                  matInput
                  type="text"
                  (input)="onSearchChange($event.target.value)"
                />
              </mat-form-field>
            </div>
            <div class="selectRecordsDiv" style="width: 9.5%">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label i18n="@@Targetrecords" style="color: black"
                  >Records</mat-label
                >
                <mat-select
                  [(ngModel)]="pageSize"
                  (ngModelChange)="onPageSizeChanged()"
                >
                  <mat-option value="10" selected>10</mat-option>
                  <mat-option value="200">200</mat-option>
                  <mat-option value="300">300</mat-option>
                  <mat-option value="400">400</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="card pagination paginationFirstButton paginationFirstlastButton"
            >
              <em
                class="fas fa-angle-double-left waves-effect waves-light"
                (click)="onBtFirst()"
              ></em>
            </div>
            <div class="card pagination paginationButtons btn-rounded">
              <ul>
                <li class="paginationliicon">
                  <em
                    class="fas fa-angle-left waves-effect waves-light"
                    (click)="onBtPrevious()"
                  ></em>
                </li>
                <li>{{ currentPage }}/{{ totalPages }}</li>
                <li class="paginationliicon" style="padding: 0">
                  <em
                    class="fas fa-angle-right waves-effect waves-light"
                    (click)="onBtNext()"
                  ></em>
                </li>
              </ul>
            </div>
            <div
              class="card pagination paginationLastButton paginationFirstlastButton"
            >
              <em
                class="fas fa-angle-double-right waves-effect waves-light"
                (click)="onBtLast()"
              ></em>
            </div>
          </mat-toolbar>

          <ag-grid-angular
            class="ag-theme-balham table-width-screen tablestyles square scroolbar-dusty-grass square thin"
            (gridReady)="onGridReadyFullData($event)"
            [hidden]="!true"
            [columnDefs]="columnDefsFullDataLoad"
            [animateRows]="true"
            [pagination]="true"
            [rowSelection]="rowSelection"
            [defaultColDef]="defaultColDef"
            [suppressPaginationPanel]="true"
            [rowHeight]="35"
            [headerHeight]="35"
            [enableBrowserTooltips]="true"
            [floatingFiltersHeight]="45"
            [paginationPageSize]="paginationPageSize"
            [paginationNumberFormatter]="paginationNumberFormatter"
            [enableRangeSelection]="true"
            [debug]="true"
            [rowClassRules]="rowClassRules"
            (paginationChanged)="onPaginationChanged()"
            [components]="components"
          ></ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>
<div></div>
